import React from 'react';
import { quotingFeaturesData } from '../../data/distributorsData';
import { CheckCircle, FileText, Clock, Zap } from 'lucide-react';

const QuotingSection = () => {
  return (
    <section className="py-24 bg-dark-ellipse">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-white/10 text-white rounded-full text-sm font-medium mb-4 border border-white/20">
              Cotización Automatizada
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Impulsa ventas con cotización automatizada
            </h2>
            <p className="text-lg text-white/80 mb-8 leading-relaxed">
              Genera cotizaciones precisas instantáneamente desde catálogos unificados y convíertelas en pedidos con workflows automatizados.
            </p>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-6">
              {quotingFeaturesData.map((feature, idx) => (
                <div key={feature.id} className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/10 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <CheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <h4 className="font-bold text-white mb-1 text-sm">{feature.title}</h4>
                      <p className="text-white/70 text-xs leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="bg-white rounded-3xl p-8 shadow-2xl">
              {/* Quote Generator Mock */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                    <FileText className="w-5 h-5 text-white" />
                  </div>
                  <span className="font-semibold text-gray-900">Generador de Cotizaciones</span>
                </div>
                <span className="text-[#1297fd] text-sm font-medium">Nuevo</span>
              </div>

              {/* Quote Form Mock */}
              <div className="space-y-4 mb-6">
                <div className="bg-gray-50 rounded-xl p-4">
                  <label className="text-xs text-[#c3c3c5] mb-1 block">Cliente</label>
                  <p className="text-gray-900 font-medium">TechCloud Solutions</p>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-50 rounded-xl p-4">
                    <label className="text-xs text-[#c3c3c5] mb-1 block">Producto</label>
                    <p className="text-gray-900 font-medium">Microsoft 365 E3</p>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-4">
                    <label className="text-xs text-[#c3c3c5] mb-1 block">Cantidad</label>
                    <p className="text-gray-900 font-medium">250 licencias</p>
                  </div>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <label className="text-xs text-[#c3c3c5] mb-1 block">Descuento aplicado</label>
                  <div className="flex items-center justify-between">
                    <p className="text-gray-900 font-medium">Volumen Gold (-15%)</p>
                    <span className="text-green-500 font-bold">-$4,125</span>
                  </div>
                </div>
              </div>

              {/* Quote Summary */}
              <div className="bg-[#1297fd]/5 rounded-xl p-4 mb-6 border border-[#1297fd]/20">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[#c3c3c5]">Subtotal</span>
                  <span className="text-gray-900">$27,500</span>
                </div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[#c3c3c5]">Descuento</span>
                  <span className="text-green-500">-$4,125</span>
                </div>
                <div className="border-t border-[#1297fd]/20 pt-2 mt-2">
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-gray-900">Total</span>
                    <span className="font-bold text-[#1297fd] text-xl">$23,375</span>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button className="flex-1 py-3 rounded-xl font-semibold text-white" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  Generar cotización
                </button>
                <button className="px-4 py-3 rounded-xl border border-[#e3e4e6] text-gray-600 hover:bg-gray-50 transition-colors">
                  <Clock className="w-5 h-5" />
                </button>
              </div>

              {/* Speed Indicator */}
              <div className="flex items-center justify-center gap-2 mt-4">
                <Zap className="w-4 h-4 text-[#1297fd]" />
                <span className="text-sm text-[#c3c3c5]">Cotización generada en <span className="text-[#1297fd] font-medium">2.3 segundos</span></span>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 bg-green-500 text-white rounded-2xl p-3 shadow-xl transform rotate-3">
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5" />
                <span className="font-medium text-sm">Aprobado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuotingSection;
